import {
  StyleSheet,
  ImageBackground,
  useWindowDimensions,
  SafeAreaView,
  Image,
} from "react-native";
import React from "react";

import {
  View,
  ScrollView,
  Heading,
  Text,
  Pressable,
  Box,
  VStack,
  Center,
} from "native-base";
import Card from "../../components/Card";
import { StackScreenProps } from "../../types";
import Header from "../../components/Header";
import { RenderItem } from "../../components/RenderItem";

const Production = ({ navigation }: StackScreenProps<"ResearchAndDev">) => {
  const { height, width } = useWindowDimensions();

  return (
    <ImageBackground
      source={require("../../assets/bulk_blending.png")}
      resizeMode="cover"
      style={{ width, height }}
    >
      <View style={styles.overlay}>
        <SafeAreaView style={{ height }}>
          <ScrollView px={10}>
            <Header
              onPress={() => navigation.navigate("Production")}
              parentText="Production"
              headingText="Bulk Blending Plants"
              // intro="With a total investment of $43.1 million, OCP Africa is currently deploying three ultra-modern bulk blending plants in Kaduna, Ogun and Sokoto with a storage capacity of approximately 100,000MT and a blending capacity of approximately 500,000MT per year. Each agricultural center of excellence will hold a process building for storage of raw materials, blending and bagging of finished product, laboratory for quality control, workshop for maintenance and repairs, locker room, canteen and administrative building. These facilities will provide technical support for a new entrant in the blending and for Agro-dealers to grow to blending plant owners under the PFI scheme, allow introduction of new customized formulas attuned to farmers’ needs and expand supply to meet market growth."
            />

            <Text textAlign={"center"} alignSelf="center" mb={4}>
              With a total investment of $43.1 million, OCP Africa is currently
              deploying three ultra-modern bulk blending plants in Kaduna, Ogun
              and Sokoto with a storage capacity of approximately 100,000MT and
              a blending capacity of approximately 500,000MT per year. Each
              agricultural center of excellence will hold a process building for
              storage of raw materials, blending and bagging of finished
              product, laboratory for quality control, workshop for maintenance
              and repairs, locker room, canteen and administrative building.
              These facilities will provide technical support for a new entrant
              in the blending and for Agro-dealers to grow to blending plant
              owners under the PFI scheme, allow introduction of new customized
              formulas attuned to farmers’ needs and expand supply to meet
              market growth.
            </Text>

            <Text textAlign={"center"} alignSelf="center" mb={4}>
              Each agricultural center of excellence will hold a process
              building for storage of raw materials, blending and bagging of
              finished product, laboratory for quality control, workshop for
              maintenance and repairs, locker room, canteen and administrative
              building.
            </Text>

            <Text textAlign={"center"} alignSelf="center" mb={10}>
              These facilities will provide technical support for a new entrant
              in the blending and for Agro-dealers to grow to blending plant
              owners under the PFI scheme, allow introduction of new customized
              formulas attuned to farmers’ needs and expand supply to meet
              market growth.
            </Text>

            <Box w={320} h={350} margin="auto">
              <ImageBackground
                source={require("../../assets/blocks.png")}
                style={{
                  width: 320,
                  height: 350,
                  borderRadius: 35,
                  overflow: "hidden",
                  borderWidth: 5,
                  borderColor: "white",
                }}
                imageStyle={{
                  borderRadius: 15,
                  backgroundColor: "rgba(0,0,0,.8)",
                }}
              >
                <Center style={styles.cardOverlay}>
                  {/* <Image
                    source={require("../../assets/playicon.png")}
                    style={{ height: 40, width: 40 }}
                  /> */}

                  <iframe
                    src="https://www.youtube.com/embed/aW7PeGMwbHM"
                    title=""
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: 15,
                      overflow: "hidden",
                      borderWidth: 2,
                      borderColor: "white",
                    }}
                    // frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    // allowfullscreen
                  ></iframe>
                </Center>
              </ImageBackground>
            </Box>

            <View mb={20} mt={10}>
              {[
                require("../../assets/gallery/blendingplant/blendingplant1.jpg"),
                require("../../assets/gallery/blendingplant/blendingplant2.jpg"),
                require("../../assets/gallery/blendingplant/blendingplant3.jpg"),
                require("../../assets/gallery/blendingplant/blendingplant4.jpg"),
                require("../../assets/gallery/blendingplant/blendingplant5.jpg"),
              ].map((item, index) => RenderItem({ item, index }))}
            </View>

            <View style={{ height: 20 }}></View>
          </ScrollView>
        </SafeAreaView>
      </View>
    </ImageBackground>
  );
};

export default Production;

const styles = StyleSheet.create({
  shadow: {
    shadowOffset: { width: 0, height: 20 },
    shadowRadius: 20,
    shadowOpacity: 0.6,
    shadowColor: "#000000",
    elevation: 20,
  },
  buttonShadow: {
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 1,
    shadowOpacity: 0.3,
    shadowColor: "#000000",
    elevation: 5,
  },
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "#540114e6",
  },
  cardOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  },
});
